import { uniq } from 'ramda';
import { rangeStep } from '@moda/portal-stanchions';

/**
 * The open-ended cutoff (currently 75) or any additional breakpoint can be
 * changed here — bucket widths and labels are derived from this array alone.
 */
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const MARKDOWN_PERCENTAGE_BUCKET_KEYS: number[] = [30, 40, 50, 60, 75];

const MAX_PERCENTAGE = 100;

/**
 * A bucket covers every value up to (but not including) the next key, so
 * adjacent buckets always tile the full range with no gaps or overlaps.
 */
export const getBucketWidth = (key: number, sortedKeys: number[]) => {
  const index = sortedKeys.indexOf(key);
  const isLast = index === sortedKeys.length - 1;
  const nextKey = isLast ? Infinity : sortedKeys[index + 1];

  return nextKey - key;
};

export const expandBucketKeysToRawValues = (selectedKeys: string[]): string[] => {
  const sortedKeys = [...MARKDOWN_PERCENTAGE_BUCKET_KEYS].sort((previous, next) => previous - next);

  return uniq(
    selectedKeys
      .map(selected => Number(selected))
      // Drop unknown values (e.g. a bookmarked link using a bucket key from a
      // previous version of MARKDOWN_PERCENTAGE_BUCKET_KEYS) instead of
      // producing an invalid range.
      .filter(key => sortedKeys.includes(key))
      .flatMap(key => {
        const isLast = sortedKeys.indexOf(key) === sortedKeys.length - 1;
        const width = getBucketWidth(key, sortedKeys);
        const upperBound = isLast ? MAX_PERCENTAGE : key + width - 1;

        return rangeStep(key, upperBound + 1, 1).map(String);
      })
  );
};
